import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputAdornment } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers/TimePicker';
import { makeStyles } from '@mui/styles';
import { isValid, parseISO } from 'date-fns';
import React, { FC } from 'react';

const toDate = (v: Date | string | null | undefined): Date | undefined => {
  if (!v) return undefined;
  if (typeof v !== 'string') return v;
  const p = parseISO(v);
  return isValid(p) ? p : new Date(v);
};

const ClockIcon = () => <FontAwesomeIcon icon="clock" size="xs" />;

const useStyles = makeStyles((theme: any) => ({
  input: {
    '&:focus': { backgroundColor: theme.palette.background.default },
    '& .MuiFilledInput-root': {
      textTransform: 'none',
      fontSize: '0.875rem',
      color: theme.palette.text.primary,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      backgroundColor: theme.palette.background.default,
    },
  },
  naked: {
    '&:focus': { backgroundColor: theme.palette.background.default },
    '& .MuiFilledInput-input': {
      paddingTop: 10,
      paddingLeft: 0,
    },
    '& .MuiFilledInput-root': {
      textTransform: 'none',
      fontSize: '0.875rem',
      color: theme.palette.text.primary,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      backgroundColor: 'transparent',
    },
  },
  icon: { padding: 0, marginRight: 0 },
}));

type ParsableDate = string | number | Date | null | undefined;

type TimePickerProps = {
    value: ParsableDate;
    onChange: (date: Date | null, value?: string | null | undefined) => void
    label?: React.ReactNode
    disabled?: boolean
}

const TimePicker: FC<TimePickerProps> = ({ value, onChange, label, disabled = false }) => {
  const classes = useStyles();
  const dateValue = value === null || value === undefined || value === '' ? null : new Date(value);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MuiTimePicker
        value={dateValue}
        label={label}
        onChange={(date) => onChange(date)}
        disabled={disabled}
        className={classes.input}
        slots={{
          openPickerIcon: () => (
            <InputAdornment position="end">
              <FontAwesomeIcon icon="clock" size="xs" />
            </InputAdornment>
          ),
        }}
        slotProps={{
          textField: { fullWidth: true, variant: 'filled' },
          openPickerButton: { className: classes.icon },
        }}
      />
    </LocalizationProvider>
  );
};

export default TimePicker;